export type Call = {
    id: number,
    body: string,
    callFromNumber: string,
    ownerId: string,
    timeStamp: Date | null
}

export const defaultCall: Call = {id: 0, body: "", callFromNumber: "", ownerId: "0", timeStamp: null }; 